import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Progress } from '@/components/ui/progress';
import { Loader2 } from 'lucide-react';
import { useTemplateApplyStore } from '../stores/template-apply-store';

export function TemplateApplyDialog() {
  const isApplying = useTemplateApplyStore((s) => s.isApplying);
  const templateName = useTemplateApplyStore((s) => s.templateName);
  const stage = useTemplateApplyStore((s) => s.stage);
  const progress = useTemplateApplyStore((s) => s.progress);

  return (
    <Dialog open={isApplying} onOpenChange={() => {}} modal>
      <DialogContent
        className="sm:max-w-[360px] pointer-events-none"
        hideCloseButton
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader className="space-y-4 pt-4">
          <div className="flex items-center justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
          <div className="space-y-2 text-center">
            <DialogTitle>{templateName ? `${templateName} 적용 중` : '템플릿 적용 중'}</DialogTitle>
            <DialogDescription>{stage}</DialogDescription>
          </div>
        </DialogHeader>
        <div className="space-y-2 px-1 pb-2">
          <Progress value={progress} className="h-2" />
          <div className="text-center text-xs text-muted-foreground">{Math.round(progress)}%</div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
